import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import ActionMenu from '../../../components/ActionMenu';
import { formatDateForTable, formatPhoneForTable, getStatusBadgeColors, formatStatusLabel } from '../utils/formatters';
import styles from './Clinics.module.scss';
export const createClinicsTableColumns = (handleSetActive, handleSetRejected, handleSetOnHold, handleSetInactive, handleDelete, handleView, navigate) => [
    {
        key: 'endurance_account_number',
        header: 'Endurance Account Number (EAN)',
        render: (clinic) => clinic.accountNumber || 'N/A',
    },
    {
        key: 'name',
        header: 'Clinic Name',
        render: (clinic) => clinic.name || 'N/A',
    },
    {
        key: 'sales_rep',
        header: 'Sales Rep',
        render: (clinic) => (clinic.salesRepDetail
            ? `${clinic.salesRepDetail.salesRepId} - ${clinic.salesRepDetail.name}`
            : 'Unassigned'),
    },
    {
        key: 'contact_name',
        header: 'Contact Name for Clinic',
        render: (clinic) => clinic.contactName || "N/A",
    },
    {
        key: 'contact_email',
        header: 'Contact Email Address',
        render: (clinic) => {
            const email = clinic.email;
            if (email) {
                return (_jsx("a", { href: `mailto:${email}`, className: styles.linkText, onClick: (e) => e.stopPropagation(), children: email }));
            }
            else {
                return 'N/A';
            }
        },
    },
    {
        key: 'phone',
        header: 'Clinic Phone',
        render: (clinic) => {
            const phone = formatPhoneForTable(clinic);
            return phone && phone !== 'N/A' ? (_jsx("a", { href: `tel:${phone.replace(/\D/g, '')}`, className: styles.linkText, onClick: (e) => e.stopPropagation(), children: phone })) : 'N/A';
        },
    },
    {
        key: 'date_registered',
        header: 'Date Registered',
        render: (clinic) => (_jsx("span", { style: { cursor: 'pointer' }, onClick: () => navigate(`/web-admin/clinics/${clinic.id}`), children: formatDateForTable(clinic.createdAt || clinic.created_at || clinic.date_registered) })),
        sortable: true,
    },
    {
        key: 'status',
        header: 'Status',
        accessor: 'approvalStatus',
        render: (clinic) => {
            const status = clinic.approvalStatus || clinic.approval_status || 'pending';
            const { background, text } = getStatusBadgeColors(status);
            return (_jsx(StatusBadge, { label: formatStatusLabel(status), bgColor: background, color: text }));
        },
    },
    {
        key: 'actions',
        header: 'Action',
        render: (clinic) => {
            return (_jsx("div", { onClick: (e) => e.stopPropagation(), children: _jsx(ActionMenu, { options: [
                        { label: 'View Details', onClick: () => handleView(clinic) },
                        { label: 'Approve', onClick: () => handleSetActive(clinic) },
                        { label: 'Reject', onClick: () => handleSetRejected(clinic) },
                        { label: 'Put On Hold', onClick: () => handleSetOnHold(clinic) },
                        { label: 'Set as Inactive', onClick: () => handleSetInactive(clinic) },
                        { label: 'Delete', onClick: () => handleDelete(clinic), color: 'red' },
                    ] }) }));
        },
    },
];
